/**
 * Created by Eran.Shain on 11/24/2016.
 */
import type { IWidget } from "../widget-types/types";
import type { IDataFetcher, IDataFetcherFactory } from "./IDataFetcher";
import widgetResource from "app/common/resources/widgetResource";
import {
    fetchWithFullResponseConfig,
    fetchWithFullResponseInterceptorHandlers,
} from "app/components/widget/widget-fetchers/DefaultDataFetcher";

class UniqueVisitorsFetcherFactory<T> implements IDataFetcherFactory<T> {
    create(widget: IWidget<T>): IDataFetcher<T> {
        const resource = widgetResource.websiteAppsResource(
            widget.apiParams.metric,
            fetchWithFullResponseConfig,
        ).SingleMetric;
        return {
            fetch: () => resource(widget.apiParams).then(...fetchWithFullResponseInterceptorHandlers),
            destroy: () => undefined,
        };
    }
}

export default new UniqueVisitorsFetcherFactory();
